"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorApp = void 0;
/**
 * This class is a wrapper of the Learnosity author app, it has only the methods used by assessments.
 */
var AuthorApp = /** @class */ (function () {
    function AuthorApp(authorApp) {
        this.authorApp = authorApp;
    }
    AuthorApp.prototype.saveActivity = function () {
        return this.authorApp.saveActivity();
    };
    AuthorApp.prototype.getActivity = function () {
        return this.authorApp.getActivity();
    };
    AuthorApp.prototype.getActivityItems = function () {
        return this.authorApp.getActivityItems();
    };
    AuthorApp.prototype.setActivity = function (activity) {
        return this.authorApp.setActivity(activity);
    };
    AuthorApp.prototype.setActivityTitle = function (title) {
        var activity = this.getActivity();
        activity.data.config.title = title;
        return this.setActivity(activity);
    };
    AuthorApp.prototype.destroy = function () {
        return this.authorApp.destroy();
    };
    return AuthorApp;
}());
exports.AuthorApp = AuthorApp;
